import React from "react";

export default function planActive(props) { 
    return <div>
        active plan
    </div>
 }